var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"inner-content",domProps:{"innerHTML":_vm._s(_vm.details.txt)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }